import { Configuration, BrowserCacheLocation, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import getAppConfig from "../appConfigService";

const isProdEnv = process.env.NODE_ENV === "production";


function getMsalConfig() {
    const { azureAd: { tenantName, clientId, policies, loginDomain } } = getAppConfig();

    const configuration: Configuration = {
        auth: {
            clientId,
            authority: `https://${loginDomain!}/${tenantName}.onmicrosoft.com/${policies.login}`,
            knownAuthorities: [loginDomain!],
            navigateToLoginRequestUrl: false,
            redirectUri: window.location.origin            
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage,
            storeAuthStateInCookie: false
        },
        system: {
            loggerOptions: {
                loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            isProdEnv || console.info(message);
                            return;
                        case LogLevel.Verbose:
                            isProdEnv || console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                    }
                },
                piiLoggingEnabled: false
            }
        }
    };

    return configuration;
}


// Lazy create singleton MSAL public client instance.
let _msalClient: PublicClientApplication;
export function getMsalInstance() {
    if (!_msalClient) {
        const configuration = getMsalConfig();
        _msalClient = new PublicClientApplication(configuration);
    }
    return _msalClient;
}


// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const getAzureAdScopes = () => getAppConfig().azureAd.scopes;


export const getCurrentAccount = (throwIfNotFound = true) => {
    const account = getMsalInstance().getAllAccounts()[0]  || null;
    if (!account) {
        throw new Error("No logged in user found");
    }
    return  account;    
}


// Get the OID (object id) for the currently logged in user.  This is the user identified in Azure AD B2C
export const getCurrentUserOID = (throwIfNotFound = true) => getCurrentAccount(throwIfNotFound)?.localAccountId;